<template>
  <form id="live-streaming-send-gift-modal" action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">プレゼントを贈る</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <div class="giftlist">
          <div
            v-for="(gift, index) in gifts"
            :key="index"
            :class="
              selectedGift && selectedGift.id == gift.id
                ? 'giftlist__item selected'
                : 'giftlist__item'
            "
            @click="onGiftSelected(gift)"
          >
            <div class="giftlist__image image">
              <img :src="gift.iconURL">
            </div>
            <div class="doron-info-container">
              <div class="doron-icon-container">
                <img
                  v-if="gift.doronType == 'doron'"
                  src="../assets/image/doron/doron.svg"
                />
                <img
                  v-if="gift.doronType == 'freeDoron'"
                  src="../assets/image/doron/doronFree.svg"
                />
              </div>
              <div class="doron-amount-container">{{ gift.price }}</div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          label="プレゼントを贈る"
          @click="submit"
          :loading="submitting"
          :disabled="!canSend"
        />
      </footer>
    </div>
  </form>
</template>

<script>
import * as reserveServices from '@/services/reserveServices';
import * as doronServices from '@/services/doronServices';
import * as DateTime from '@/utils/date';
import * as modal from '@/utils/modal';
import * as gifts from '@/consts/gifts';

export default {
  name: 'LiveStreamingSendGiftModal',
  props: {
    mode: {
      type: String,
      default: 'open'
    },
    castId: String,
    liveId: String
  },
  data() {
    return {
      gifts: [],
      selectedGift: null,
      canSend: false,
      submitting: false
    };
  },
  created() {
    this.loadGifts();
  },
  methods: {
    loadGifts() {
      let list = gifts.list[this.mode];
      for (let item of list) {
        item.iconURL = require(`../assets/image/gifts/${item.id}.png`);
      }
      this.gifts = list;
    },
    async submit() {
      if (!this.selectedGift) return;
      this.submitting = true;

      let timestamp = await DateTime.serverDate();
      const payload = {
        userId: this.$store.state.auth.uid,
        nickname: this.$store.state.user.nickname,
        photoURL: this.$store.state.user.photoURL,
        iconURL: this.selectedGift.iconURL,
        giftId: this.selectedGift.id,
        giftNameJP: this.selectedGift.nameJP,
        isPaid: this.selectedGift.doronType == "doron" ? 1 : 0,
        price: this.selectedGift.price,
        withAnimation: this.selectedGift.withAnimation,
        type: 'gift',
        timestamp: timestamp.toSeconds(),
        period: DateTime.addToUnix(this.selectedGift.period, 'seconds', timestamp)
      };

      // purchase item
      await this.$store.dispatch('doron/purchaseItem', this.selectedGift);
      await doronServices.addPurchaseHistory(doronServices.PURCHASE_KIND.GIFT, this.$store.state.auth.uid, this.castId, this.liveId, this.selectedGift.doronType, this.selectedGift.price);

      // push comment
      this.$emit('setCommentPayload', payload);

      // reset state
      this.selectedGift = null;
      this.submitting = false;
      this.$emit('close');
    },
    async onGiftSelected(gift) {
      this.selectedGift = gift;
      if (gift.doronType == 'freeDoron') {
        if (this.$store.getters['doron/freeDoronAmount'] < gift.price) {
          this.$buefy.toast.open({
            duration: 3000,
            message: '無償ゴールドが不足しています。無償ゴールドは、有償ゴールド購入時に付与されます。',
            type: 'is-warning'
          });
          this.canSend = false;
          return;
        }
      } else {
        let doron = this.$store.getters['doron/doronAmount'];
        let reservePoint = await reserveServices.getReservePoint(this.$store.state.auth.uid);

        if (doron < gift.price) {
          modal.openPointLackModal(this);
          this.canSend = false;
          return;
        } else if (doron < gift.price + reservePoint) {
          modal.openPointLackModal(this,
            `予約中限定配信があるため、<br/>ゴールドが不足しています。<br/>ゴールドを購入しますか？<br/><br/><scan class="thin">保有ゴールド：${doron}pt</scan><br/><scan class="thin">限定配信予約中ゴールド：${reservePoint}pt</scan><br/><scan class="thin">不足ゴールド：${(gift.price + reservePoint) - doron}pt</scan>`
          );
          this.canSend = false;
          return;
        }
      }
      this.canSend = true;
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/live-streaming-send-gift-modal.scss';
.selected {
  background-color: #fcdf7b;
}
.doron-info-container {
  margin: auto;
  width: fit-content;
  height: 20px;
  display: flex;
  align-items: center;
  .doron-icon-container {
    width: 20px;
    height: 20px;
  }
  .doron-amount-container {
    margin: 0 0 0 8px;
  }
}
</style>
